<template>
    <div class="product-insights green-border-box">
      <div v-if="!loading">
        <h4 style="margin-left:10px;">Qualitative Data Activity</h4>
          <apexcharts :options="chartOptions" :series="series"></apexcharts>
      </div>
      <h4 v-else style="text-align: center;">Loading Insight Details...</h4>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ProductInsights',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId'],
  data: function () {
    return {
      loading: true,
      chartOptions: {
        chart: {
          title: {
            text: 'State Insights'
          },
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      series: [ {
        data: []
      }
      ]
    }
  },
  methods: {
    getSurveyInsights () {
      this.$store.dispatch('getBrandsurveyInsights', this.brandId)
        .then(
          (response) => {
            this.series[0].data = response.body
            this.loading = false
          }
        )
    }
  },

  mounted () {
    this.getSurveyInsights()
  },
  watch: {

  }
}
</script>
